var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.028 0 0 4.028 0 9s4.028 9 9 9 9-4.028 9-9-4.028-9-9-9m0 16.258A7.256 7.256 0 0 1 1.742 9 7.256 7.256 0 0 1 9 1.742 7.256 7.256 0 0 1 16.258 9 7.256 7.256 0 0 1 9 16.258m2.243-3.789L8.162 10.23a.44.44 0 0 1-.178-.352V3.92c0-.24.196-.435.435-.435h1.162c.24 0 .435.196.435.435v5.143l2.424 1.763a.435.435 0 0 1 .095.61l-.683.94a.44.44 0 0 1-.61.094"
  })));
};
export default SvgClock;